/**
 * @class
 */
import Base from 'netxcore@netx/core-app/views/appModalCrumbView';

import {faTimes} from '@netx/core-icons';
const icons = Base.initializeIcons({
	faTimes,
});

export default class AppModalCrumbView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.icons = {...icons, ...opts.icons};
		super(opts);
	}
	/** @override */
	postRender() {
		super.postRender();
		this.$el.addClass('primary-background primary-border');
	}
}
